import config from './multilingualSeoLandingPages.json';

export const LOCALIZED_SEO_LANDING_PAGES = Array.isArray(config.pages) ? config.pages : [];

export const LOCALIZED_SEO_LANDING_ROUTE_DEFINITIONS = LOCALIZED_SEO_LANDING_PAGES.map((page) => ({
  key: page.key,
  nonDefaultLanguageCodes: Array.isArray(page.languages)
    ? page.languages.filter((entry) => entry.code !== 'en').map((entry) => entry.code)
    : [],
}));

export const getLocalizedSeoLandingDefinition = (pageKey) =>
  LOCALIZED_SEO_LANDING_PAGES.find((page) => page.key === pageKey);

export const getLocalizedSeoLandingLanguageEntry = (pageKey, code) => {
  const page = getLocalizedSeoLandingDefinition(pageKey);
  if (!page || !Array.isArray(page.languages)) {
    return null;
  }
  return page.languages.find((entry) => entry.code === code) || null;
};

export const getLocalizedSeoLandingCanonicalPath = (pageKey) => {
  const page = getLocalizedSeoLandingDefinition(pageKey);
  if (!page) {
    return '/';
  }

  return (
    page.xDefaultPath ||
    page.languages?.find((entry) => entry.code === 'en')?.path ||
    page.languages?.[0]?.path ||
    '/'
  );
};

export const buildLocalizedSeoLandingAlternates = (pageKey) => {
  const page = getLocalizedSeoLandingDefinition(pageKey);
  if (!page || !Array.isArray(page.languages)) {
    return [];
  }

  const canonicalPath = getLocalizedSeoLandingCanonicalPath(pageKey);
  return [
    {
      hrefLang: 'en',
      path: canonicalPath,
    },
    {
      hrefLang: 'x-default',
      path: canonicalPath,
    },
  ];
};
